<template>
  <div class="parent-container">
    <div class="image-container"></div>
    <div class="login-container vld-parent" ref="rootElement">
      <div class="login-inner-container">
        <h1 class="text-blue">Welcome</h1>
        <br />
        <div>
          <form v-on:submit.prevent id="loginForm">
            <input
              type="text"
              class="form-control mb-2"
              id="username"
              v-model="username"
              placeholder="username"
              ref="username"
              required
            />
            <input
              type="password"
              class="form-control mb-2"
              id="password"
              v-model="password"
              placeholder="password"
              required
            />
          </form>
        </div>
        <div class="login-button-container">
          <button class="btn btn-blue" type="submit" form="loginForm" v-on:click="login">Login</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Utils from "@/utils.js";
import axios from "axios";
import {
  LOGIN_ACTION,
  SET_INIT_DATA_ACTION,
  SET_REQUESTED_BY_DOCTORS_ACTION,
  SET_COLLECTION_CENTERS_ACTION
} from "@/store-constants.js";

export default {
  name: "Login",
  data() {
    return {
      username: "",
      password: ""
    };
  },

  mounted() {
    this.$refs.username.focus();
  },

  methods: {
    login() {
      if (!document.getElementById("loginForm").checkValidity()) {
        return;
      }

      let loading = this.$loading.show({
        container: this.$refs.rootElement
      });

      axios
        .post(Utils.getURL("/login"), {
          username: this.username,
          password: this.password
        })
        .then(resp => {
          var token = resp.data.token;

          loading.hide();
          this.$store.dispatch(LOGIN_ACTION, token);
          this.$router.push("/");

          // init call
          axios
            .get(Utils.getURL("/init"))
            .then(response => {
              var data = response.data.results;
              this.$store.dispatch(SET_INIT_DATA_ACTION, data);

              // get patient register additional data
              axios
                .get(Utils.getURL("/patient/getAdditionalInformationValues"))
                .then(res => {
                  const data = res.data.results[0].values;

                  let allRequestedBy = [];
                  if (data["requestedBy"]) {
                    allRequestedBy = Array.from(
                      new Set(
                        data["requestedBy"]
                          .map(v => v.trim())
                          .filter(v => v.length > 0)
                      )
                    ).sort();
                  }
                  this.$store.dispatch(
                    SET_REQUESTED_BY_DOCTORS_ACTION,
                    allRequestedBy
                  );

                  let allCollectionCenters = [];
                  if (data["collectionCenter"]) {
                    allCollectionCenters = Array.from(
                      new Set(
                        data["collectionCenter"]
                          .map(v => v.trim())
                          .filter(v => v.length > 0)
                      )
                    ).sort();
                  }
                  this.$store.dispatch(
                    SET_COLLECTION_CENTERS_ACTION,
                    allCollectionCenters
                  );
                })
                .catch(() => {
                  Utils.notifyError(
                    "There has been an error in getting patient register additional information."
                  );
                });
            })
            .catch(() => {
              Utils.notifyError("There has been an error in the init call");
            });
        })
        .catch(() => {
          loading.hide();
          Utils.notifyError("Login failed, please try again.");
        });
    }
  }
};
</script>

<style>
.parent-container {
  display: flex;
  justify-content: center;
  height: 100%;
  /* background-color: var(--app-background-color); */
}

.image-container {
  flex-basis: 70%;
  background-image: url("../assets/background.jpg");
  background-size: cover;
  background-position: center;
}

.login-container {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-basis: 30%;
}

.login-inner-container {
  width: 70%;
}

.login-button-container {
  display: flex;
  justify-content: flex-end;
}

h1 {
  font-family: arial-black;
}

@media (max-width: 768px) {
  .image-container {
    display: none;
    flex-basis: 0%;
  }

  .login-container {
    flex-basis: 100%;
  }
}

/* @media (max-width:1024px) {
    .image-container {
      flex-basis: 50%;
    }

    .login-container {
      flex-basis: 50%;
    }
  } */
</style>
